module.exports = __webpack_public_path__ + "static/fcra-2020-21-q1-436008a310514738fd7f83349cad7821.pdf";